import { Form, Select, Skeleton, Spin } from 'antd';
import { useLazyGetEmployeesForSubstitutionQuery } from 'app/services/edpApiV1/substitutions/substitution';
import { EmployeesUi } from 'entities/employees';
import { useEffect, useState } from 'react';
import { uiModel } from 'entities/ui';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useDebounce } from 'shared/hooks';

interface IProps {
  divisionId?: string;
  disabled?: boolean;
  loading?: boolean;
  searchDivisionId?: string;
  resetValueWhenObservebleVarChange?: boolean;
  disabledWhenLoading?: boolean;
  label?: string;
}

export const SearchEmployeesField: React.FC<IProps> = ({
  disabled,
  divisionId,
  loading,
  searchDivisionId,
  disabledWhenLoading,
  label,
}) => {
  const { Item } = Form;
  const { Option } = Select;
  const dispatch = useAppDispatch();

  const [searchValue, setSearchValue] = useState<string | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const debounceSearchValue = useDebounce(searchValue);

  const options = useAppSelector(uiModel.Substitutions.selectors.getSearchEymployeesOptions);

  const [getEmployees, { data, isFetching, isLoading }] = useLazyGetEmployeesForSubstitutionQuery();

  useEffect(() => {
    getEmployees({
      divisionId,
      search: debounceSearchValue,
      page: currentPage,
      size: 10,
      // searchDivisionId: searchDivisionId,
    });
  }, [debounceSearchValue, currentPage, getEmployees, divisionId, searchDivisionId]);

  const onFocus = () => {
    getEmployees({
      divisionId,
      search: debounceSearchValue,
      page: currentPage,
      size: 10,
      // searchDivisionId: searchDivisionId,
    });
  };

  const onChange = (value: string) => {
    setSearchValue(value.length >= 1 ? value : undefined);
  };

  const onSelect = (value: string) => {
    dispatch(uiModel.Substitutions.actions.setSelectedEymployerId(value));
  };

  const onClear = () => {
    setSearchValue(undefined);
    dispatch(uiModel.Substitutions.actions.setSelectedEymployerId());
  };

  const onDropdownVisibleChange = () => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (!searchValue) {
      dispatch(uiModel.Substitutions.actions.setEymployeesOptions([]));
    }
  }, [searchValue]);

  return (
    <>
      <Item
        name="employeeId"
        label={label || 'Выберите сотрудника'}
        shouldUpdate
        rules={[
          {
            required: true,
            message: 'Выберите сотрудника',
          },
        ]}
        required
      >
        {loading ? (
          <Skeleton.Button active block />
        ) : (
          <Select
            showSearch
            placeholder="ФИО или табельный номер сотрудника"
            disabled={disabled || (disabledWhenLoading && (isLoading || isFetching))}
            filterOption={false}
            onSearch={onChange}
            loading={isLoading || isFetching}
            onSelect={onSelect}
            onFocus={onFocus}
            notFoundContent={(() => {
              if (isFetching) {
                return <Spin size="small" />;
              } else {
                return searchValue ? 'По вашему запросу сотрудник не найден' : null;
              }
            })()}
            onClear={onClear}
            onPopupScroll={(e: any) => {
              e.persist();
              const target = e.target;
              if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
                if (data && data?.pagination.total / (currentPage * 10) > 1) {
                  setCurrentPage(currentPage + 1);
                }
              }
            }}
            onDropdownVisibleChange={onDropdownVisibleChange}
            allowClear
          >
            {options.length !== 0 &&
              options.map(item => (
                <Option key={item?.id} value={item?.id}>
                  <EmployeesUi.SummaryInfo user={item} />
                </Option>
              ))}
          </Select>
        )}
      </Item>
    </>
  );
};
